"use client";

import React, { FC, useEffect, useState } from "react";

import TweetEmbed from "react-tweet-embed";

import { themeType } from "lib/types";
import { useCurrentLocale, usePreferredTheme } from "lib/utils";

export interface TwitterProps {
  id: string;
}
const Twitter: FC<TwitterProps> = ({ id }) => {
  const { preferredTheme } = usePreferredTheme();
  const locale = useCurrentLocale();
  const [tweetTheme, setTweetTheme] = useState<themeType | undefined>(
    undefined,
  );

  // Stupid workaround to make theme switching work
  useEffect(() => {
    if (preferredTheme === "dark") setTweetTheme("dark");
    else if (preferredTheme === "light") setTweetTheme("light");
  }, [preferredTheme]);

  return tweetTheme !== undefined ? (
    <div style={{ colorScheme: "auto" }}>
      <TweetEmbed
        key={tweetTheme === "light" ? "1" : "2"}
        options={{
          theme: tweetTheme,
          conversation: "none",
          lang: locale,
        }}
        tweetId={id}
      />
    </div>
  ) : null;
};

export default Twitter;
